import * as queryString from 'query-string';
import React from 'react';

export interface NaturalLanguageProps {
  readonly dataSourceUrlName: string;
  readonly siteUrlName: string; // note that for the default site, this is ""
}

export class NaturalLanguage extends React.Component<NaturalLanguageProps> {
  private viz: tb.IViz;
  private nlpElement: HTMLElement | null;

  public constructor(props: NaturalLanguageProps) {
    super(props);
  }

  public render(): JSX.Element {
    return <div ref={this.setNLPElementRef} style={{ flexGrow: 1 }} />;
  }

  private setNLPElementRef = (element: HTMLElement | null) => {
    this.nlpElement = element;
    this.embedNlpWorkbook();
  }

  public embedNlpWorkbook(): void {
    if(!this.nlpElement) {
      return;
    }

    if(this.viz) {
      this.viz.dispose();
    }
    const url = this.getNlpWorkbookUrl();
    this.viz = new tableau.Viz(this.nlpElement, url, { width: '100%', height: '100%' });
  }

  componentDidUpdate(prevProps: NaturalLanguageProps) {
    if(this.props.dataSourceUrlName !== prevProps.dataSourceUrlName || this.props.siteUrlName !== prevProps.siteUrlName) {
        this.embedNlpWorkbook();
    }
  }

  componentWillUnmount() {
    this.nlpElement = null;
    if(this.viz) {
      this.viz.dispose();
    }
  }

  private getNlpWorkbookUrl(): string {
    // This URL is based off of the line in httpd.conf.templ that mentions startAskData
    const baseUrl = window.location.origin;
    const siteUrl = this.props.siteUrlName === '' ? '' : `/t/${this.props.siteUrlName}`;
    // This is to enable us to use the main feature flag system, by copying url parameters to the embeded workbook
    const params = queryString.stringify(queryString.parseUrl(window.location.href).query, { encode: false });
    const parameters = params.length > 1 ? '?' + params : '';
    return `${baseUrl}${siteUrl}/startAskData/${this.props.dataSourceUrlName}${parameters}`;
  }
}
